import { render, staticRenderFns } from "./FeedbackDetails.vue?vue&type=template&id=3e352483&scoped=true"
import script from "./FeedbackDetails.vue?vue&type=script&lang=ts"
export * from "./FeedbackDetails.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackDetails.vue?vue&type=style&index=0&id=3e352483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e352483",
  null
  
)

export default component.exports